import { CreateNode } from "@react-admin/ra-tree";
import { SimpleForm } from "react-admin";
import TreeNodeForm from "./TreeNodeForm";

const TreeNodeCreate = () => {
  return (
    <CreateNode
      mutationMode="pessimistic"
      title="Създай нов елемент"
      mutationOptions={{ meta: { useFormData: false } }}
    >
      <SimpleForm>
        <TreeNodeForm />
      </SimpleForm>
    </CreateNode>
  );
};

export default TreeNodeCreate;
